import { connect } from 'react-redux';
import MobileFooterMenu, {
  MobileFooterMenuProps,
} from '@components/MobileFooterMenu';
const mapStateToProps = (state): MobileFooterMenuProps => {
  const {
    location: { type },
  }: {
    location: any;
  } = state;
  return {
    location: type,
  };
};

export default connect(mapStateToProps)(MobileFooterMenu);
